import { getIPForVisitor } from './get-ip-address';
import { getCookie, setCookie } from './cookie_utils';


export function loadThirdPartyAndCookiesOnConsent() {
    // Loads all third party code and cookies, and
    // dismisses future banner pop ups for first time
    // EU users that hit the accept button on the banner
    setCookie('samsara_cookies', 'fn, an, ad', 180);
    setCookie('cookieconsent_status', 'dismiss', 180);

    import('./analytics_cookies.js')
    .then((analyticsCookies) => {
        // Since user is EU OptimizelyOptOut is set to true
        // by default so it needs a one-time update to false
        window["optimizely"] = window["optimizely"] || [];
        window["optimizely"].push({
            "type": "optOut",
            "isOptOut": false
        });
        analyticsCookies.runAnalytics("$opt_in");
    });
    import('./advertising_cookies.js')
    .then((advertisingCookies) => {
        advertisingCookies.runAdvertising();
    });
    // Remove cookie banner
    document.getElementById('cookie-consent-placeholder').innerHTML = ''
}

export function redirectToCookieConsent() {
    // Redirects EU users to cookie consent page where
    // they can opt in to specific catergories of cookies
    mixpanel.opt_in_tracking({'track_event_name': 'Cookie Consent Redirect'});
    mixpanel.opt_out_tracking();

    const prefix_to_add = document.getElementById('prefix').content;
    if (prefix_to_add) {
        window.location = prefix_to_add + '/legal/cookie-consent';
    } else {
        window.location = '/legal/cookie-consent';
    }
}

export function loadThirdPartyAndCookiesFirstTime() {
    // This function is run for first time non-EU visitors
    // It sets cookies to dismiss consent logic in future
    // and then loads all third party code and set cookies
    setCookie('samsara_cookies', 'fn, an, ad', 180);
    setCookie('cookieconsent_status', 'dismiss', 180);

    import('./analytics_cookies.js')
    .then((analyticsCookies) => {
        analyticsCookies.runAnalytics();
    });
    import('./advertising_cookies.js')
    .then((advertisingCookies) => {
        advertisingCookies.runAdvertising();
    });

    getIPForVisitor().then(function(ipAddress){
        if (ipAddress){
            mixpanel.register({"IP Address": ipAddress});
        }
    })
}

export function loadThirdPartyAndCookies() {
    // This code is run for all non first time users
    // It runs all third party code and sets cookies
    // that users has accepted to or all if non-EU
    const cookiePreferences = getCookie('samsara_cookies');

    if (cookiePreferences.includes('an')) {
        import('./analytics_cookies.js')
        .then((analyticsCookies) => {
            analyticsCookies.runAnalytics();
        });
    }
    if (cookiePreferences.includes('ad')) {
        import('./advertising_cookies.js')
        .then((advertisingCookies) => {
            advertisingCookies.runAdvertising();
        });
    }

    const mixpanelCookie = getCookie("mp_81f04dbeb4db7ff80420f5b348506aa7_mixpanel");
    if ((cookiePreferences.includes('an')) && mixpanelCookie) {
        const loadedMixpanelCookie = JSON.parse(mixpanelCookie);
        // if Mixpanel cookie already has "IP Address" set
        // don't make another network request
        if(!loadedMixpanelCookie.hasOwnProperty("IP Address")) {
            getIPForVisitor().then(function(ipAddress){
                if (ipAddress){
                    mixpanel.register({"IP Address": ipAddress});
                }
            })
        }
    }
}
